import React from 'react';
import './landpage.scss';
import FAQ from '../../components/FAQ/faq';
import Header from '../header/header';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion"
import Footer from '../../components/Footer/footer';
import CardCarousel from '../../components/card/cardCarousel';
import NewsletterForm from '../../components/newsletter/newsletter';
import DownloadPage from '../download/download';

const FitnessLandingPage = () => {
  return (
    <>
      <Header />
      <div id="about"className="landing-page">
        <section className="landing-about">
          <div className="landing-about__header">
            <h1>It's a Whole New App</h1>
          </div>

          <div className="landing-about__content">
            <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="landing-about__image landing-about__image--left">
              <img src="https://res.cloudinary.com/dsnontai6/image/upload/v1758998698/Orter/undraw_chatting_2b1g_wuw9pj.svg" alt="fitness" />
            </motion.div>

            <div className="landing-about__text">
              <h4>Unleash Your Voice</h4>
              <p>
                <strong><span>Orter</span></strong> lets you express your thoughts and ask real questions without fear. 
                Connect anonymously with people who share your interests, values, or challenges. Whether it’s relationships, 
                mental health, faith, or everyday life; there’s always someone to listen, share, and help.

              </p>
              <Link to="/download" className="landing-about__button">Download the App</Link>
            </div>

            {/* <div className="landing-about__image landing-about__image--right">
              <img src="https://res.cloudinary.com/dsnontai6/image/upload/v1745930829/pexels-cottonbro-5474294_ihabvb.jpg" alt="fitness" />
            </div> */}
          </div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="landing-about__image landing-about__image--bottom">
            <img src="https://res.cloudinary.com/dsnontai6/image/upload/v1758998697/Orter/undraw_mobile-marketing_7x7m_kzhbou.svg" alt="fitness" />
          </motion.div>
        </section>

        <section id="features"className="landing-learn-more">
        <div className="landing-learn-more__left">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.4 }} className='landing-learn-more__ttt'>
              <h3 className="landing-learn-more__title">Learn More</h3>
              <h4 className="landing-learn-more__subtitle">Our Purpose</h4>
              <p className="landing-learn-more__text">
            At Orter, we believe everyone deserves a space to talk freely without labels, fear, or social pressure. <br/><br/>
            Too many people keep their questions or emotions bottled up because they’re afraid of being judged. Orter creates 
            a bridge for open, anonymous, and compassionate communication where you can find understanding, advice, or just 
            someone to listen.<br/><br/>
            From individuals seeking answers to organizations fostering private support communities, Orter empowers real connection through anonymity.
          </p>
          {/* <Link to='/features' initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.4 }}className="landing-learn-more__button">Discover More</Link> */}
          </motion.div>

        </div>

        <div className="landing-learn-more__right">
          <div className="landing-learn-more__image landing-learn-more__image--top">
            <img src='https://images.pexels.com/photos/36675/pexels-photo.jpg' alt="Person working at computer" />
          </div>
        </div>
      </section>

      <section>
        <CardCarousel />
      </section>
      

      <section className="subscribe2">
      <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className='text'
      >
        <NewsletterForm />
      </motion.div>
      </section>
      <Footer />
      </div>
    </>
  );
};

export default FitnessLandingPage;